<header>
    <h1>Lyrics and Quotes</h1>
</header>

<style>
    header {
        background: #f7f7f7;
        margin: 0;
        padding: 20px;
        width: 100%;
        height: 3em;
        position: fixed;
        top:0;
        left: 0;
    }

    h1 {
        margin: 0;
        text-align: left;
    }

</style>